import { render } from "./AnswerCard.vue?vue&type=template&id=34a0abf9&scoped=true"
import script from "./AnswerCard.vue?vue&type=script&lang=js"
export * from "./AnswerCard.vue?vue&type=script&lang=js"

import "./AnswerCard.vue?vue&type=style&index=0&id=34a0abf9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a0abf9"]])

export default __exports__